<template>
  <section>
    <div class="standardItem3">
      <span>{{ obj.article_name }}</span>
      <span>
        <div class="standardItem3-box">
          <img
            v-for="(item, index) in obj.img_url"
            :key="index"
            :src="decodeURIComponent(item)"
          >
        </div>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComDtoData3',
  components: {},
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
.standardItem3 {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 16px;
  overflow: hidden;
  > span {
    &:nth-child(1) {
      font-family: "AdobeHeitiStd-Regular";
      font-size: 20px;
      color: #555;
      text-align: center;
      margin-bottom: 20px;
    }
    &:nth-child(2) {
      // height: 1000px;
      // overflow-y: auto;
    }
  }
  &-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    >img{
      width: 75%;
    }
  }
}
</style>
